module.exports = [
  require('./vargouille'),
  require('./vegepygmy'),
  require('./vegepygmy_chief'),
  require('./velociraptor'),
]
